export default __webpack_public_path__ + "static/media/NFO_PostLogin_Multi_Factor_Passive_FoF_Hero_desktop.5a23b1df.jpg";